var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 379,
    height: 48,
    viewBox: "0 0 379 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.9091 24.4145C54.3198 23.0043 47.9672 18.2875 34.4545 17.8462C24.6722 17.5266 15.962 19.63 8.30353 22.3392C3.20356 24.1434 0 29.1161 0 34.5258C0 41.9674 6.03259 48 13.4742 48H368.419C374.263 48 379 43.2629 379 37.4194C379 25.7505 360.527 23.149 349.902 27.9735C348.16 28.7643 346.373 29.1992 344.545 29.1992C328.449 29.1992 324.519 4.58455 310.091 1.19243C295.663 -2.19968 288.988 13.7199 275.636 14.934C262.285 16.1481 251.68 10.6748 241.182 8.9552C230.684 7.23563 219.217 4.48081 206.727 7.83154C194.238 11.1823 187.723 33.2593 172.273 36.9102C156.822 40.561 151.6 29.1992 137.818 27.4196C124.036 25.6401 117.845 26.4078 103.364 25.8247C88.882 25.2416 83.4984 25.8247 68.9091 24.4145Z",
    fill: "url(#paint0_linear_1_725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_725",
    x1: -5.45682,
    y1: 14.5714,
    x2: 229.179,
    y2: 216.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43BFFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00EFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962409,
    stopColor: "#00EFC0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSvg);
export default __webpack_public_path__ + "static/media/waveSvg.d16c0747942e1f1fdffa9de001be614d.svg";
export { ForwardRef as ReactComponent };